/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const InstagramLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6m0-2a5 5 0 1 1 0 10 5 5 0 0 1 0-10m6.5-.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0M12 4c-2.47 0-2.88 0-4.03.06-.78.03-1.3.14-1.8.33a3 3 0 0 0-1.08.7c-.33.34-.53.65-.7 1.08-.19.5-.3 1.02-.33 1.8A70 70 0 0 0 4 12c0 2.47 0 2.88.06 4.03.04.78.14 1.3.33 1.8a3 3 0 0 0 1.78 1.78c.5.2 1.02.3 1.8.33 1.1.05 1.5.06 4.03.06 2.48 0 2.88 0 4.03-.06.78-.03 1.3-.14 1.8-.33a3 3 0 0 0 1.78-1.78c.2-.5.3-1.02.33-1.8.05-1.1.06-1.5.06-4.03 0-2.47 0-2.88-.06-4.03a6 6 0 0 0-.33-1.8 3 3 0 0 0-.7-1.08 3 3 0 0 0-1.08-.7 5 5 0 0 0-1.8-.33C14.93 4 14.54 4 12 4m0-2c2.72 0 3.06.01 4.12.06 1.07.05 1.8.22 2.43.46.66.26 1.22.6 1.77 1.16.56.55.9 1.11 1.16 1.77.24.64.41 1.36.46 2.43C22 8.94 22 9.28 22 12s0 3.06-.06 4.12a7 7 0 0 1-.46 2.43c-.26.66-.6 1.22-1.16 1.77-.55.56-1.11.9-1.77 1.16a7 7 0 0 1-2.43.46c-1.06.05-1.4.06-4.12.06s-3.05-.01-4.12-.06a7 7 0 0 1-2.43-.46 5 5 0 0 1-1.77-1.16 5 5 0 0 1-1.15-1.77 7 7 0 0 1-.47-2.43C2.01 15.06 2 14.72 2 12s.01-3.06.06-4.12c.05-1.07.22-1.8.47-2.43.25-.66.6-1.22 1.15-1.77a5 5 0 0 1 1.77-1.16 7 7 0 0 1 2.43-.46C8.95 2.01 9.28 2 12 2" />
  </Icon>
);
